module.exports = __webpack_public_path__ + "img/ic_emoji_neutral.3907ee50.png";